module.exports = __webpack_public_path__ + "static/img/Contact us X bar.779ed96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/Contact us X bar.png
// module id = fV7r
// module chunks = 1